//Declaramos las acciones que acurrirán.
export const actionLogged = {
    type: 'isAuthenticated'
}

export const actionLoggedOut = {
    type: 'notAuthenticated'
}


